module.exports = __webpack_public_path__ + "static/media/YF35_0.786f2638.jpg";